const debug                 = false;
myApp.nativeUI.about      = {};

//
// Open about Window
myApp.nativeUI.about.init = function () {
    if(debug) console.log('Open About Menu');


    // Make sure our window does not exist yet (to avoid, that we open it up twice)
    if(myApp.aboutWindow !== null && myApp.aboutWindow !== undefined)
        return false;


    // Create a new Window element for our about menu
    myApp.aboutWindow = myApp.nw.Window.open('resources/views/about.html', {
        position: 'center',
        width: 650,
        height: 400,
        resizable: false,
        focus: true
    } , function(win) {
        myApp.aboutWindow = win;

        // Get the Tray button, that links to this menu & disable it.
        // Makes the user aware the about are already open & prevents multiple calls
        let trayButton = myApp.nativeUI.tray.menu.items.filter(obj => { return obj.label === 'About'; });
        trayButton[0].enabled = false;

        //
        // Register Element events

        // Focus hack, to ensure the about window remains always focused
        myApp.mainWindow.on('focus', function() {
            myApp.aboutWindow.focus();
        });

        // Clear up all linked data from our Object
        myApp.aboutWindow.on('closed', function() {
            trayButton[0].enabled   = true;
            myApp.aboutWindow.removeAllListeners('focus');
            myApp.aboutWindow     = null;
        });
    });
};